import {
  FlowlineSettings,
  ActivitySettings,
  ActivityType,
  DiagramGeneralSettings
} from '../diagram-type-styles.model';
import {UPNBaseConfig} from './diagram-upn-base-config';
import {CUSTOMER_JOURNEY} from '../../../shared/constants/diagram-subtypes.constants';
import {MAPS_TYPES_ENUM as MAP_TYPES} from '../../../editor-interface/shared/models/map.model';

const defaultFlowlineShape = {w: 140, h: 0} as const;

export class CustomerJourneyConfig extends UPNBaseConfig {
  generalSettings(): DiagramGeneralSettings {
    return {
      ...super.generalSettings(),
      tagName: 'Customer Journey',
      tagColor: '#01897b',
      canAutoGenerateDrilldown: true,
      allowedDrilldownSubtypes: [
        MAP_TYPES.CUSTOMER_JOURNEY,
        MAP_TYPES.UPN,
        MAP_TYPES.INTERACTION_FLOW,
        MAP_TYPES.AGENT_INSTRUCTION
      ]
    };
  }

  readonly activityShape = {w: 150, h: 115};

  readonly activityTypes: ActivityType[] = [
    {
      tooltip: 'ASIDE_L.CUSTOMER_JOURNEY_DEFAULT_ACTIVITY_TOOLTIP',
      icon: 'activity_icon_v2',
      settings: (x?: number, y?: number) => this.activitySettings(x, y)
    }
  ];

  activitySettings(x?: number, y?: number): ActivitySettings {
    const defaultResources = this.getDefaultResources([
      CUSTOMER_JOURNEY.DEFAULT_RESOURCES.CUSTOMER
    ]);

    return {
      ...super.activitySettings(x, y),
      text: CUSTOMER_JOURNEY.ACTIVITY_TEXT,
      defaultResources,
      createActivityWithFlowline: true
    };
  }

  flowlineSettings(x?: number, y?: number, id?: number | string): FlowlineSettings {
    return {
      ...super.flowlineSettings(x, y, id),
      defaultFlowlineShape,
      config: {
        ...super.flowlineSettings(x, y, id).config,
        srcType: 'activity',
        tgtType: 'none',
        text: CUSTOMER_JOURNEY.FLOWLINE_TEXT,
        tgtPosition: {
          x: x + this.activityShape.w + defaultFlowlineShape.w,
          y: y + this.activityShape.h / 2
        },
        position: {
          connectionPoints: {
            exitX: 1,
            exitY: 0.5
          },
          offset: {x: 0, y: 0},
          x: 0,
          y: 60
        },
        srcId: Number(id) ?? null,
        tgtId: null
      }
    };
  }
}
